import { SEOHead } from "@/components/seo/SEOHead";
import { Button } from "@/components/ui/button";
import { openCookieSettings } from "@/utils/gdprConsent";
import { useRoOnlyGuard } from '@/hooks/useRoOnlyGuard';

export default function PoliticaCookies() {
  const __roBlocked = useRoOnlyGuard();
  return (
    <>
      <SEOHead
        title="Politica de Cookies - ROAutoMarket"
        description="Ce cookies folosim, în ce scop și cum îți poți gestiona preferințele."
        canonicalPath="/politica-cookies"
      />
      <div className="container mx-auto px-4 py-10 max-w-4xl">
        <div className="surface-dark band-bleed -mt-10 mb-8 py-6"><h1 className="text-3xl md:text-4xl font-bold">Politica de Cookies</h1></div>
        <div className="prose prose-neutral dark:prose-invert max-w-none space-y-6">
          <p className="text-sm text-muted-foreground">Ultima actualizare: 25.09.2026</p>

          <section>
            <h2 className="text-2xl font-semibold mb-3">1. Ce sunt cookies</h2>
            <p>
              Cookies sunt fișiere mici de text stocate de browser pe dispozitivul tău atunci când vizitezi un site.
              Ele ne ajută să recunoaștem dispozitivul și să oferim o experiență mai bună.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">2. Categorii de cookies folosite</h2>

            <h3 className="text-xl font-semibold mt-4 mb-2">Cookies necesare</h3>
            <p>Indispensabile pentru funcționarea platformei (autentificare, securitate, preferințe de limbă/țară).
              Nu pot fi dezactivate și nu necesită consimțământ.</p>

            <h3 className="text-xl font-semibold mt-4 mb-2">Cookies de analiză</h3>
            <p>Ne ajută să înțelegem cum este folosit site-ul (PostHog, Sentry). Datele sunt agregate sau pseudonimizate.
              Se activează doar cu consimțământul tău.</p>

            <h3 className="text-xl font-semibold mt-4 mb-2">Cookies de marketing</h3>
            <p>Folosite pentru reclame personalizate și măsurarea campaniilor (Meta Pixel).
              Se activează doar cu consimțământul tău.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">3. Cum îți gestionezi preferințele</h2>
            <p>Poți schimba alegerea oricând:</p>
            <Button onClick={openCookieSettings}>Deschide setările de cookies</Button>
            <p className="mt-3">De asemenea, poți șterge cookies direct din setările browser-ului.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">4. Temei legal</h2>
            <p>
              Articolul 5(3) din Directiva 2002/58/CE (ePrivacy), articolul 4 alin. (5) din Legea 506/2004 și
              articolul 7 GDPR. Cookies neesențiale sunt activate doar pe baza consimțământului tău explicit.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">5. Contact</h2>
            <p>Întrebări: <a href="mailto:contact@roautomarket.ro" className="text-primary hover:underline">contact@roautomarket.ro</a></p>
          </section>
        </div>
      </div>
    </>
  );
}
